import { render, staticRenderFns } from "./SocialSecurityTaxable.vue?vue&type=template&id=7dd669fe&scoped=true&"
import script from "./SocialSecurityTaxable.vue?vue&type=script&lang=js&"
export * from "./SocialSecurityTaxable.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=7dd669fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd669fe",
  null
  
)

export default component.exports